import React from "react";
import { Modal } from "@mui/material";
import Button from "../../components/common/button/Button";

const ModalProvider = ({
  isOpen,
  onClose,
  title,
  description,
  cancelBtn,
  sendBtn,
}) => {
  return (
    <>
      <Modal
        open={isOpen}
        onClose={onClose}
        className="flex items-center justify-center"
      >
        <div className="py-[30px] px-[37px] w-4/12  rounded-[16px] bg-white-0 ">
          <p className="text-xl font-interSemiBold text-center">{title}</p>
          <p className="text-center pt-3 pb-3">{description}</p>
          <div className="flex justify-around">
            <Button
              type={"submit"}
              onClick={() => cancelBtn()}
              className=" bg-gray-1 font-interSemiBold text-blue-1 text-lg h-[48px] w-full mr-3  p-[8px] 2xl:p-[12px] rounded-[8px] lg:text-md 2xl:text-lg flex items-center justify-center mt-3 border border-blue-1"
            >
              No
            </Button>
            <Button
              type={"submit"}
              onClick={() => sendBtn()}
              className=" bg-red-2 font-interSemiBold text-white-0 text-lg h-[48px] w-full  p-[8px] 2xl:p-[12px] rounded-[8px] lg:text-md 2xl:text-lg flex items-center justify-center mt-3"
            >
              Yes
            </Button>
          </div>
        </div>
      </Modal>
    </>
  );
};

export default ModalProvider;
